
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ghWhZhbyp8jesIbS50dEmr1mKMav1gCZ396hVh2Z7PI0Meta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexRnIB4SuS5UE_45noeHo9I_45NExI_45hJmbHVq4ow_JmAdzBUMeta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchh4Q0gxJ5FjXndIJWCsb7TfcsfjK7CVGChGDelOekNCEMeta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexbml8LFKZWreMWsSg5Z_nZNVOramER_45eBaRGtZ6HiWK4Meta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93k3O8O65yJRfQI_45uaW0v0lyFYvdgvUHBFrio9BAYCXv0Meta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexgRTKOS9Xf8cHTY_zAQLh3_45s3Nc5dAxyLZU2QSf1lnbYMeta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_937dgRYwJ_45krGyZO87Laa9nzP6tpqd2wH_pbg7cES9LJQMeta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexZe9zxd_45KUsPVCvmJ_45AFY7ootuzteJK_45J8MhCt_0lvIEMeta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_938JQYsliNGrHqlPbLUDruWi0nx_45VP4pxC9LRU_QP26pYMeta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexmGrf6eTzZ_45SOGAvpENzfcwqwead1Zxf3HjlM0zJHD_450Meta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexoU1R0f0vyoHmxjNtztmPilpd2d6XZ8U3EPb9q4Oml1kMeta } from "/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexgRTKOS9Xf8cHTY_zAQLh3_45s3Nc5dAxyLZU2QSf1lnbYMeta || {},
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexZe9zxd_45KUsPVCvmJ_45AFY7ootuzteJK_45J8MhCt_0lvIEMeta || {},
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexmGrf6eTzZ_45SOGAvpENzfcwqwead1Zxf3HjlM0zJHD_450Meta || {},
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexoU1R0f0vyoHmxjNtztmPilpd2d6XZ8U3EPb9q4Oml1kMeta || {},
    component: () => import("/codebuild/output/src443588678/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]